import { VectorProps } from "../types/vectors"

const IconArrowDown = ({ size="24", primary="currentColor" }: VectorProps) => {
  return (
    <svg width={size} height={size} viewBox="0 -960 960 960" fill={primary} xmlns="http://www.w3.org/2000/svg">
      <path d="M440-800v487L216-537l-56 57 320 320 320-320-56-57-224 224v-487h-80Z"/>
    </svg>
  )
}

export default IconArrowDown